/**
 * /app/{slug}/helpdesk/new — New helpdesk ticket form.
 *
 * Renders the HelpdeskNewTicketForm (subject, category, priority, description).
 * On success the form navigates back to /helpdesk with a success toast.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/shared/page-header";
import { HelpdeskNewTicketForm } from "@/components/helpdesk/helpdesk-new-ticket-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/helpdesk/new",
)({
  component: NewHelpdeskTicketPage,
});

function NewHelpdeskTicketPage() {
  return (
    <>
      <PageHeader
        title="New ticket"
        description="Submit a request to the helpdesk."
      />
      <Card className="max-w-2xl">
        <CardContent className="pt-6">
          <HelpdeskNewTicketForm />
        </CardContent>
      </Card>
    </>
  );
}
